import React from 'react'
import './CalendarContainer.scss'
import {get} from 'lodash'
import GetStarted from './GetStarted'
import StepDots from './StepDots'
import ReservationLanding from './ReservationLanding'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import {UserContext} from '../../../context/User'
import WelcomeUser from './WelcomeUser'
import {Grid} from '@material-ui/core'
import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  background: {
    background: '#182954',
  },
})

const CalendarContainer = () => {
  const classes = useStyles()
  const [step, setStep] = React.useState(1)
  const user = React.useContext(UserContext)
  const handleNext = e => {
    e.preventDefault()
    setStep(prev => prev + 1)
  }

  return (
    <>
      <Grid container className={classes.background}>
        <Grid item xs={4}>
          <div className="left-sec" />
        </Grid>
        <Grid item xs={8} className="bg-white">
          {!user.details || user?.details?.isLoading ? (
            <LoadingIndicator
              style={{
                width: '100%',
                marginTop: '200px',
              }}
            />
          ) : (
            <div className="right-sec">
              <div className="text-content">
                {step === 1 && <WelcomeUser next={handleNext} />}
                {step === 2 && <GetStarted />}
              </div>
              <StepDots step={step} stepCount={2} />
            </div>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default CalendarContainer
